import type { ReactNode } from 'react';
import type { SkeletonProps } from 'react-loading-skeleton';
import Skeleton from 'react-loading-skeleton';

export interface SkeletonWrapperProps extends SkeletonProps {
  isLoading?: boolean;
  children: ReactNode;
}

export function SkeletonWrapper({ children, isLoading = false, ...props }: SkeletonWrapperProps): React.JSX.Element {
  if (isLoading) {
    return <Skeleton {...props} />;
  }
  return <>{children}</>;
}
